import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent } from "@mui/material";
import "./Cards.css";
import moment from "moment";
import { APIURL } from "../../config";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import ArticleIcon from '@mui/icons-material/Article';
import IconButton from "@mui/material/IconButton";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import GestureIcon from '@mui/icons-material/Gesture';
import { convertTime } from "src/utils/time";

// A task card on the project Tasks tab, with its signature dialog.
const ProjectTaskCard = (props) => {
  const [signLoading, setSignLoading] = useState(false);
  const [showSignPopover, setShowSignPopover] = useState(false);
  const [signUrl, setSignUrl] = useState("");
  const [location, setLocation] = useState("-");

  async function handleShowSignPopover() {
    if (showSignPopover) {
      setShowSignPopover(false);
    } else {
      setSignLoading(true);
      setShowSignPopover(true);
      let signature = await axios
        .get(APIURL + "/signature", {
          params: { task_id: props.task.tas_id },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "image/png" });
          const url = URL.createObjectURL(blob);
          if (props.task.checkoutLocId) {
            let loc = props.locList.find((loc) => loc.loc_id === props.task.checkoutLocId);
            setLocation(loc.loc_addr_line1 + ", " + (loc.loc_addr_line2 ? loc.loc_addr_line2 + ", " : "") + loc.loc_city + ", " + loc.loc_state + ", " + loc.loc_zip);
          }
          setSignUrl(url);
          setSignLoading(false);
        }).catch((err) => {
          setSignUrl("Something went wrong. Please try again later.");
          setSignLoading(false);
        });
    }
  }

  return (
    <div>
      <div className="TaskCard">
        {/* {setEmpDetails(props.all_employees, props.emp_id)} */}
        <div className="TaskHeader">
          <h6>{props.title}</h6>
          <li>
            <span>
              Scheduled: {convertTime(props.start_time, props.task.task_emp_timezone, moment.tz.guess(), "MMM DD, hh:mm A") ?? moment(props.start_time.replace(/Z/g, "")).format("MMM DD, hh:mm A")} - {convertTime(props.end_time, props.task.task_emp_timezone, moment.tz.guess(), "MMM DD, hh:mm A") ?? moment(props.end_time.replace(/Z/g, "")).format("MMM DD, hh:mm A")}

            </span>
          </li>
        </div>
        <div className="TaskHeaderTwo">
          <span>{props.task_type}</span>
          <span>Actual: {convertTime(props.task.empLocdate, props.task.empLocate_timezone, moment.tz.guess(), "MMM DD, hh:mm A") ?? moment(props.task.empLocdate?.replace(/Z/g, "")).format("MMM DD, hh:mm A")} - {convertTime(props.task.checkoutEmpDate, props.task.empLocate_timezone, moment.tz.guess(), "MMM DD, hh:mm A") ?? moment(props.task.checkoutEmpDate?.replace(/Z/g, "")).format("MMM DD, hh:mm A")}</span>
        </div>
        <div className="TaskHeaderThree">
          {moment().isAfter(moment(props.end_date).add(1, "d")) &&
            props.is_active === 0 && <span className="overDue" style={{}}>Overdue</span>}
          {props.task.tas_is_active !== 1 && <i
            className="fas fa-trash"
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.deleteTask(props.task_id, props.title);
            }}
          ></i>}
          {props.is_active !== 1 && !props.isCheckedIn && (
            <i
              className="fas fa-edit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.showModal
                  ? props.showModal(props.task)
                  : props.editForm(props.task_id);
              }}
            ></i>
          )}



        </div>
        <hr className="HorizontalLine" style={{}}></hr>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 2 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <span>
                  <i className="fas fa-user-alt"></i>
                </span>
                <span style={{ marginLeft: "10px" }}>
                  {props.employeeDets.emp_first_name}{" "}
                  {props.employeeDets.emp_last_name}
                </span>
              </div>
              <div>
                {props.task.tas_required_sig === 1 && props.task.tas_is_active === 1 &&
                  <Tooltip title={"Signed on " + (convertTime(props.task.checkoutEmpDate, props.task.empLocate_timezone, moment.tz.guess(), "MMM DD, hh:mm A") ?? moment(props.task.checkoutEmpDate).utc().format("MMM DD, hh:mm A"))} >
                    <IconButton onClick={() => handleShowSignPopover()} size="small">
                      <GestureIcon />
                    </IconButton>
                  </Tooltip>
                }
                {props.task?.customerForm && props.task?.customerForm.length > 0 &&
                  <Tooltip title="Forms" >
                    <IconButton size="small" onClick={() => props.handleCusFormsShow(props.task)}>
                      <FormatListBulletedIcon />
                    </IconButton>
                  </Tooltip>}
                {props.isSupport && props.task?.monthly_monitoring_id &&
                  <Tooltip title="MT Task" >
                    <IconButton size="small" onClick={() => props.handleFormShow(props.task)}>
                      <ArticleIcon />
                    </IconButton>
                  </Tooltip>}
              </div>
            </div>
            {/*             <div>
              <span>
                <i className="fas fa-map-marker-alt"></i>
              </span>
              <span style={{ marginLeft: "14px" }}>
                {props.taskLoc.loc_addr_line1 +
                  " " +
                  props.taskLoc.loc_addr_line2 +
                  " " +
                  props.taskLoc.loc_city +
                  " " +
                  props.taskLoc.loc_state +
                  " " +
                  props.taskLoc.loc_zip}
              </span>
            </div> */}
          </div>
        </div>
        {props.is_active === 1 && props?.selectedMenu == 'Clients' &&
          <div style={{ textAlign: 'right' }}>
            <Button size='small' sx={{ marginTop: '0px' }} onClick={() => {
              props.showModal
                ? props.showModal(props.task)
                : props.editForm(props.task_id);
            }}
            >View details</Button>
          </div>}
      </div>
      {props.task && <Dialog
        open={showSignPopover}
        onClose={() => setShowSignPopover(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Signature details for {props.task.tas_title}</DialogTitle>
        <DialogContent>
          {signLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
              <span class="spinner"></span>
            </div>
          ) : (
            <div className="signature-info">
              <table>
                <tbody>
                  <tr>
                    <td><strong>Customer Name:</strong></td>
                    <td>{props.customerDets.cus_name}</td>
                  </tr>
                  <tr>
                    <td><strong>Signed at Location:</strong></td>
                    <td>{location}</td>
                  </tr>
                  <tr>
                    <td><strong>Signed on:</strong></td>
                    <td>{convertTime(props.task.checkoutEmpDate, props.task.empLocate_timezone, moment.tz.guess(), "MMM DD, hh:mm a") ?? moment(props.task.checkoutEmpDate).utc().format("MMM DD, hh:mm a")}</td>
                  </tr>
                  <tr>
                    <td><strong>Signature:</strong></td>
                    <td>{signUrl === 'Something went wrong. Please try again later.' ? signUrl : <img src={signUrl} alt="Signature" className="signature-image" />}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </DialogContent>
      </Dialog>
      }
    </div>
  );
};

export default ProjectTaskCard;
